import React, { ReactNode, useEffect, useState } from 'react';
import MessageBubbleSVG from "../../svgs/MessageBubbleSVG";
import ApiService from '../../services/ApiServiceClass';
import CustomThemeModal from '../CustomThemes/CustomThemeModal';
import {  Button, Modal, Textarea } from "flowbite-react";
import { useLoader } from "../../hooks/useLoader";
import { useAuth } from '../../hooks/useAuth';

type CommentsProps = {
    requestID: number
}

type CommentType = {
    first_name: string,
    last_name: string,
    initials: string,
    comment: string,
    member_id: number
}


const Comments: React.FC<CommentsProps> = ({requestID}) => {
    const [opencommentModal, setOpenCommentModal] = useState(false);
    const [commentsCount, setCommentsCount] = useState(0);
    const [comment, setComment] = useState("");
    const [comments, setComments] = useState<CommentType[]>([]);

    const loader = useLoader();
    const auth = useAuth();


    const loadComments = () => {
        loader?.setIsLoading(true);
        try {
            ApiService.getCommentsByRequestID(requestID)
            .then((response) => {
                loader?.setIsLoading(false);                
                setCommentsCount(response.data.length);
                setComments(response?.data);
            })
            .catch((error) => {
                console.log(error);
                loader?.setIsLoading(false);
            });
        } catch(error) {

        }        
    }

    const submitComment = () => {        
        const formData = new FormData();        
        loader?.setIsLoading(true);
        const initials = auth?.getInitials() ? auth?.getInitials() : "";
        try {

            formData.append("requestID", requestID.toString());
            formData.append("comment", comment);
            formData.append("initials", initials);

            ApiService.addComment(formData)
                .then(() => {
                    loadComments();
                    loader?.setIsLoading(false);
                })
                .catch((error) => {
                    loader?.setIsLoading(false);
                    console.log(error);
                });

        } catch(error) {
            console.log(error);
        }
    }

    useEffect(() => {
        loadComments();
    }, []);
    return (
        <>
            <div className="w-full flex justify-end">
                <div className="flex grid-cols-3 my-8 items-center max-w-[200px] p-2 bg-slate-300 dark:bg-slate-500 rounded-md cursor-pointer" onClick={() => setOpenCommentModal(true)}>
                    <span className="text-orange-800 dark:text-yellow-300 mr-2"><MessageBubbleSVG /></span> <span className="text-sm">View <span className="text-green-500 dark:text-green-200">{commentsCount}</span> Comments</span>
                </div>
            </div>

            <Modal show={opencommentModal} onClose={() => setOpenCommentModal(false)} size={'xl'} theme={CustomThemeModal}>
                <Modal.Header>Comments / Messages</Modal.Header>
                <Modal.Body>
                    <div className="overflow-y-auto max-h-[13rem] dark:text-slate-400">
                        {commentsCount == 0 && <><div>No  comments yet.</div></>}   

                        {comments.map((comment, index) => {

                            if (index % 2 == 0) {
                                return (
                                    <div className="flex items-start gap-2.5 mb-5 pr-5" key={index}>
                                        <div className="flex flex-col w-full leading-1.5 px-4 pt-2 border-gray-200 bg-gray-100 rounded-tl-xl rounded-bl-xl rounded-br-xl dark:bg-gray-500">
                                            <div className="flex items-center space-x-2 rtl:space-x-reverse">
                                                <span className="text-sm font-semibold text-gray-900 dark:text-white w-full text-right">{comment.first_name} {comment.last_name}</span>
                                            </div>
                                            <p className="text-sm font-normal py-2.5 text-gray-900 dark:text-white">{comment.comment}</p>
                                        </div>
                                        <div className="relative inline-flex items-center justify-center w-10 h-10 overflow-hidden bg-gray-100 rounded-full dark:bg-gray-500">
                                            <span className="font-medium text-gray-600 dark:text-gray-300">{comment.initials}</span>
                                        </div>
                                    </div>
                                )
                            } else {
                                return (
                                    <div className="flex items-start gap-2.5 mb-5 pr-5" key={index}>
                                        <div className="relative inline-flex items-center justify-center w-10 h-10 overflow-hidden bg-gray-100 rounded-full dark:bg-gray-500">
                                            <span className="font-medium text-gray-600 dark:text-gray-300">{comment.initials}</span>
                                        </div>
                                        <div className="flex flex-col w-full leading-1.5 px-4 pt-2 border-gray-200 bg-gray-100 rounded-e-xl rounded-es-xl dark:bg-gray-500">
                                            <div className="flex items-center space-x-2 rtl:space-x-reverse">
                                                <span className="text-sm font-semibold text-gray-900 dark:text-white w-full">{comment.first_name} {comment.last_name}</span>
                                            </div>
                                            <p className="text-sm font-normal py-2.5 text-gray-900 dark:text-white">{comment.comment}</p>
                                        </div>
                                    </div>
                                )
                            }

                        })}

                    </div>
                    <div className="pb-5 mt-10 border-t-gray-500 border-solid">
                        <Textarea value={comment} onChange={(e) => setComment(e.target.value)}>
                        </Textarea>
                        <div className="w-50% flex justify-center mt-2">
                            <Button onClick={() => submitComment()}>Submit Comment</Button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

        </>        
    );
};

export default Comments;